import React from 'react';

class Slider extends React.Component {
  buildSlider() {
    let className = this.props.className;
    if (this.props.disabled) {
      className += ' disabled';
    }

    return (
      <input
        type="range"
        className={className}
        disabled={this.props.disabled}
        name={this.props.name}
        min={this.props.min}
        max={this.props.max}
        id={this.props.id}
        onChange={this.props.onChange}
        value={this.props.value}
      />
    );
  }

  render() {
    return this.buildSlider();
  }
}

export { Slider };
